import axios from 'axios';
import API_URL from '../config/api';
// SECURITY & MONITORING - COMMENTED OUT FOR NOW
// import { getStoredDeviceFingerprint } from '../utils/deviceFingerprint';

// Create axios instance with base URL from environment
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token and device fingerprint
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // SECURITY & MONITORING - COMMENTED OUT FOR NOW
    // Add device fingerprint to all requests for security tracking
    // try {
    //   const deviceFingerprint = getStoredDeviceFingerprint();
    //   if (deviceFingerprint) {
    //     config.headers['X-Device-Fingerprint'] = deviceFingerprint;
    //   }
    // } catch (error) {
    //   console.warn('Failed to get device fingerprint:', error);
    // }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Let callers opt out: background Question IDE fetches (expired session) should not
      // full-page redirect right after a successful /api/ide/execute-question (permitAll).
      if (error.config?.skipAuthRedirect) {
        return Promise.reject(error);
      }
      // Token expired or invalid
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default api;


